export default function reducer(state = {
  user: {},
  profile: {
    attributes: []
  },
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'GET_CURRENT_USER_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_CURRENT_USER_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        user: action.payLoad.data,
      };
    }
    case 'GET_CURRENT_USER_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    case 'SET_CURRENT_USER': {
      return {
        ...state,
        user: action.payLoad,
      };
    }
    case 'GET_PROFILE_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_PROFILE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        profile: action.payLoad.data,
      };
    }
    case 'GET_PROFILE_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    case 'DELETE_ACCOUNT_SUCCESS': {
      return {
        ...state,
        redirectAfterDelete: true
      };
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js